module.exports = __webpack_public_path__ + "static/media/img_recgen_min.56226d80.jpg";